import { render, staticRenderFns } from "./viewLGMUN.vue?vue&type=template&id=5c0ee35c&scoped=true"
import script from "./viewLGMUN.vue?vue&type=script&lang=js"
export * from "./viewLGMUN.vue?vue&type=script&lang=js"
import style0 from "./viewLGMUN.vue?vue&type=style&index=0&id=5c0ee35c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ee35c",
  null
  
)

export default component.exports